import { WSElement } from "@wingspanhq/fe-component-library";
import React from "react";
import wingspanLogo from "../../assets/images/ws-logo.svg";
import classes from "./styles.module.scss";

export const LoadingPlaceholder: React.FC = () => (
  <div className={classes.loadingPlaceholder}>
    <WSElement as="img" {...{ src: wingspanLogo }} />
  </div>
);
